/** Told to the editor when the Settings window asks for the Add-ons panel (it lives in a file's Assets drawer). */
export const OPEN_ADDONS = 'artwork:open-addons';
